module.exports = __webpack_public_path__ + "img/index_list_item_icon_1-new.1e93c486.png";